class A11yHelpers {

    constructor() {

    }

    /**
     * Creates child elements for elements that are given data-ofs classes along with data-ofs attributes.
     * A newly created child element will contain the value from the data-ofs attribute of its parent.
     * @param {string} childTagName 
     * @returns NodeListOf<Element>
     */
    createOffScreenContent = (childTagName, elements) => {
        const offScreenEles = elements ? elements : document.querySelectorAll('.data-ofs');
        Object.keys(offScreenEles).forEach((ele, index) => {
            if (ele && offScreenEles[index].querySelector('.a11y-hide') === null) {
                const contentInsert = document.createElement(childTagName ? childTagName : 'span');
                const ofsContent = offScreenEles[index].getAttribute('data-ofs');
                contentInsert.innerHTML = ofsContent;
                contentInsert.classList.add('a11y-hide');
                offScreenEles[index].appendChild(contentInsert);
            }
        });
        return offScreenEles;
    }

}

export default A11yHelpers;